import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import '../Journal/journal.css'
import Footer from "../footer";
import StudentSideBar from "../student/sidebar";
import CourseHeader from "../header/index";
import Bannerpage from "../Banner";
import { useDispatch, useSelector } from "react-redux";
import { ArchivegetById } from "../../Redux/Archive/archiveSlice";

const Archive = () => {

    const { archive } = useSelector((state) => state.archiveData)
    console.log(archive, "archiveee");


    const location = useLocation()
    console.log(location, "lcn")

    console.log(archive, "archeve")

    const dispatch = useDispatch();
    const { slug } = useParams();

    useEffect(() => {
        dispatch(ArchivegetById(slug));
    }, [])

    return (
        <>
            <CourseHeader activeMenu={"CourseDetails"} />
            {/* <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <div className="breadcrumb-list">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Courses
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            All Courses
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            The Complete Web Developer Course 2.0
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <Bannerpage name={slug} />

            <div className="container-fluid p-2">
                <Row>
                    <StudentSideBar classificationuuid={location?.state?.data?.journal_classification_uuid} />
                    <Col lg={8} md={8} xs={12} style={{ backgroundColor: "#fff" }}>
                        <div className="cardb">
                            <h1>Archive</h1>
                            {archive?.data?.map((item, index) => (
                                <div key={index}>
                                    <div className="cardd">
                                        <div className="card-body">
                                            {item?.year}
                                        </div>
                                    </div>
                                    {/* <ul className="">
                                        {item?.data?.filter(subItem => subItem?.issue_type === "regular").map((subItem, subIndex) => (
                                            <Link
                                                key={`regular-${subIndex}`}
                                                to={{
                                                    pathname: `/${slug}/volume-page/${subItem?.volume_issue_uuid}/${`Volume ${subItem?.volume}, Issue ${subItem?.issue}, ${item?.year}`}`
                                                }}
                                                state={{ data: item?.year }}
                                            >
                                                <li>
                                                    <i className="fas fa-chevron-right" /> Volume {subItem?.volume}, Issue {subItem?.issue}
                                                </li>
                                            </Link>
                                        ))}
                                        {item?.data?.some(subItem => subItem?.issue_type === "special") && (
                                            <div className="special-title" style={{ fontSize: "18px", fontWeight: 700 }}>Special title</div>
                                        )}
                                        {item?.data?.filter(subItem => subItem?.issue_type === "special").map((subItem, subIndex) => (
                                            <Link
                                                key={`special-${subIndex}`}
                                                to={{
                                                    pathname: `/${slug}/volume-page/${subItem?.volume_issue_uuid}/${`Special Issue: ${subItem?.title}, ${item?.year}`}`
                                                }}
                                                state={{ data: item?.year }}
                                            >
                                                <li>
                                                    <i className="fas fa-chevron-right" />  {subItem?.title}
                                                </li>
                                            </Link>
                                        ))}
                                    </ul> */}
                                    <ul className="">
                                        {/* Render sorted regular issues */}
                                        {/* Render sorted regular issues */}
                                        {(item?.data || [])
                                            .filter(subItem => subItem?.issue_type === "regular")
                                            .sort((a, b) => {
                                                if (a.volume === b.volume) {
                                                    return a.issue - b.issue;
                                                }
                                                return a.volume - b.volume;
                                            })
                                            .map((subItem, subIndex) => (
                                                <Link
                                                    key={`regular-${subIndex}`}
                                                    to={{
                                                        pathname: `/${slug}/volume-page/${`Volume-${subItem?.volume}-Issue-${subItem?.issue}-${item?.year}`}`
                                                    }}
                                                    onClick={() => window.scrollTo(0, 0)}
                                                    state={{ data: item?.year, uuid: subItem?.volume_issue_uuid }}
                                                >
                                                    <li>
                                                        <i className="fas fa-chevron-right" /> Volume {subItem?.volume}, Issue {subItem?.issue}
                                                    </li>
                                                </Link>
                                            ))}

                                        {/* Check for special issues */}
                                        {(item?.data || []).some(subItem => subItem?.issue_type === "special") && (
                                            <div className="special-title" style={{ fontSize: "18px", fontWeight: 700 }}>
                                                Special title
                                            </div>
                                        )}

                                        {/* Render sorted special issues */}
                                        {(item?.data || [])
                                            .filter(subItem => subItem?.issue_type === "special")
                                            .sort((a, b) => a.title?.localeCompare(b.title))
                                            .map((subItem, subIndex) => (
                                                <Link
                                                    key={`special-${subIndex}`}
                                                    to={{
                                                        pathname: `/${slug}/volume-page/${`Special Issue:${subItem?.title}, ${item?.year}`}`
                                                    }}
                                                    onClick={() => window.scrollTo(0, 0)}
                                                    state={{ data: item?.year, uuid: subItem?.volume_issue_uuid }}
                                                >
                                                    <li>
                                                        <i className="fas fa-chevron-right" /> {subItem?.title}
                                                    </li>
                                                </Link>
                                            ))}

                                    </ul>

                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </div>
            <Footer />
        </>
    )
}

export default Archive